export default "__VITE_ASSET__BcnhyW6P__"